module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-2-4-59b00c7880e4a1584513f1c1fea9f0ff.png";